import React from 'react';
import { Calendar, Users, Mic, Trophy, Building, BookOpen, Coffee, Star } from 'lucide-react';
import Icon from '../../../components/AppIcon';


const CategoryFilter = ({ 
  selectedCategory, 
  onCategoryChange, 
  eventCounts = {},
  loading = false 
}) => {
  // Updated categories to match database schema
  const categories = [
    { 
      id: 'all', 
      label: 'All Events', 
      icon: Star,
      color: 'text-primary'
    },
    { 
      id: 'conference', 
      label: 'Conference', 
      icon: Users,
      color: 'text-blue-500'
    },
    { 
      id: 'workshop', 
      label: 'Workshop', 
      icon: BookOpen,
      color: 'text-green-500'
    },
    { 
      id: 'networking', 
      label: 'Networking', 
      icon: Users,
      color: 'text-purple-500'
    },
    { 
      id: 'concert', 
      label: 'Concert', 
      icon: Mic,
      color: 'text-pink-500'
    },
    { 
      id: 'sports', 
      label: 'Sports', 
      icon: Trophy,
      color: 'text-orange-500'
    },
    { 
      id: 'exhibition', 
      label: 'Exhibition', 
      icon: Building,
      color: 'text-indigo-500'
    },
    { 
      id: 'seminar', 
      label: 'Seminar', 
      icon: Calendar,
      color: 'text-red-500'
    },
    { 
      id: 'meetup', 
      label: 'Meetup', 
      icon: Coffee,
      color: 'text-yellow-500'
    }
  ];

  if (loading) {
    return (
      <div className="bg-card border-b border-border">
        <div className="max-w-7xl mx-auto px-6 py-6">
          <div className="flex space-x-2 overflow-x-auto pb-2">
            {Array.from({ length: 8 })?.map((_, index) => (
              <div
                key={index}
                className="flex-shrink-0 px-4 py-2 bg-gray-200 rounded-full animate-pulse"
                style={{ width: '100px', height: '40px' }}
              />
            ))}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-card border-b border-border">
      <div className="max-w-7xl mx-auto px-6 py-6">
        <h3 className="text-lg font-semibold text-foreground mb-4">Browse by Category</h3>
        
        <div className="flex space-x-2 overflow-x-auto pb-2 scrollbar-hide">
          {categories?.map((category) => {
            const Icon = category?.icon;
            const count = eventCounts?.[category?.id] || 0;
            const isSelected = selectedCategory === category?.id;
            
            return (
              <button
                key={category?.id}
                onClick={() => onCategoryChange?.(category?.id)}
                className={`
                  flex-shrink-0 flex items-center space-x-2 px-4 py-3 rounded-lg
                  transition-colors text-sm font-medium whitespace-nowrap
                  ${isSelected
                    ? 'bg-primary text-primary-foreground shadow-md'
                    : 'bg-background text-foreground border border-border hover:bg-accent hover:text-accent-foreground'
                  }
                `}
              >
                <Icon className={`w-4 h-4 ${isSelected ? 'text-primary-foreground' : category?.color}`} />
                <span>{category?.label}</span>
                {count > 0 && (
                  <span className={`
                    px-2 py-1 rounded-full text-xs
                    ${isSelected 
                      ? 'bg-primary-foreground/20 text-primary-foreground' 
                      : 'bg-secondary text-secondary-foreground'
                    }
                  `}>
                    {count}
                  </span>
                )}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default CategoryFilter;